import { post } from '@/utils/apiClient';
import { toast } from 'react-toastify';
import { logger } from '@/utils/logger';

/**
 * Activity Center items are notification-shaped, but some alerts carry a
 * one-click staff action instead of a navigation target. Those items use the
 * `action:<verb>:<arg>` deep-link scheme; the drawer intercepts it, runs the
 * action in place, and toasts — no page navigation.
 */
export const ACTION_DEEP_LINK_PREFIX = 'action:';

export const ACTIVITY_ACTION_RESEND_INVITE = 'resend_invite';

export function parseActivityAction(deepLink: string): {
  verb: string;
  arg: string;
} | null {
  if (!deepLink.startsWith(ACTION_DEEP_LINK_PREFIX)) return null;
  const rest = deepLink.slice(ACTION_DEEP_LINK_PREFIX.length);
  const idx = rest.indexOf(':');
  if (idx <= 0) return null;
  return { verb: rest.slice(0, idx), arg: rest.slice(idx + 1) };
}

/**
 * Resend a client portal invite in place. Returns whether the send succeeded
 * so the caller can resolve the activity item.
 */
export async function resendPortalInviteAction(inviteId: string): Promise<boolean> {
  try {
    const res = await post('/api/client-portal/invite/resend', { invite_id: inviteId });
    if (res.ok) {
      toast.success('New link sent.');
      return true;
    }
    const body = await res.json().catch(() => ({}));
    toast.error(body.detail || 'Failed to resend the portal invitation.');
  } catch (e) {
    logger.error('Resend invite from Activity Center failed', e);
    toast.error('Failed to resend the portal invitation.');
  }
  return false;
}
